import api from '@/apis/di/accountingObjectAPI.js';
import apiInfo from '@/apis/di/accountingObjectInfoAPI.js';
import {usefilterActionCombo} from './filterActionCombo.js';
import {getCurrentInstance} from 'vue';
import {useStore} from 'vuex';
import {ModuleOfflineWork} from '@/stores/moduleConst';
import {ModuleAccountingObjectCache} from '@/stores/moduleConst';
import {computed} from 'vue';
// Combo grid Tài khoản nợ, có
export const useAccountingObjectComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const {proxy} = getCurrentInstance();
  const {extendFilter} = usefilterActionCombo();
  const store = useStore();

  const offlineReady = computed(() => {
    if (!store.state[ModuleOfflineWork]) {
      return false;
    } else {
      return store.state[ModuleOfflineWork].offlineReady;
    }
  });

  const dataAccountingObject = computed(() => {
    if (offlineReady.value) {
      const accountingObjects = store.getters[`${ModuleAccountingObjectCache}/items`];
      return accountingObjects.filter(x => !x.inactive);
    } else {
      return comboboxDataRemote;
    }
  });

  /**
   * Lấy dữ liệu cho combo khi offline bất ngờ
   * @returns
   */
  const getDataComboOffline = () => {
    return dataAccountingObject.value;
  };

  const queryMode = computed(() => {
    return offlineReady.value ? 'local' : 'remote';
  });

  // func call api lấy dữ liệu combo
  const onAccountingObjectComboboxLoadData = (payload, row, column, customData) => {
    payload.sort = 'is_employee,accounting_object_code';
    payload.columns += ',address, company_tax_code,';
    let ors = [{Field: 'inactive', Operator: 'NULL'}];
    let extend = [{Field: 'inactive', Value: false, Ors: ors}];
    payload.columns +=
      ',is_employee,contact_name,bank_account,bank_name,address,identification_number,issue_date,issue_by';
    payload.filter = extendFilter(payload.filter, extend);
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, customData?.callBackFn);
  };

  // func call api lấy dữ liệu combo
  const onAccountingObjectEmployeeComboboxLoadData = (payload, row, column) => {
    payload.sort = 'is_employee,accounting_object_code';
    payload.columns += ',address, company_tax_code,';
    let ors = [{Field: 'inactive', Operator: 'NULL'}];
    let extend = [
      {Field: 'inactive', Value: false, Ors: ors},
      {Field: 'is_employee', Value: true},
    ];
    payload.columns +=
      ',is_employee,contact_name,bank_account,bank_name,address,identification_number,issue_date,issue_by';
    payload.filter = extendFilter(payload.filter, extend);
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  const onCustomerComboboxLoadData = (payload, row, column) => {
    payload.sort = 'is_employee,accounting_object_code';
    payload.columns += ',address, company_tax_code,';
    let ors = [{Field: 'inactive', Operator: 'NULL'}];
    let extend = [{Field: 'inactive', Value: false, Ors: ors}];
    payload.filter = extendFilter(payload.filter, extend);
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // config columns combo
  const accountingObjectComboConfig = {
    data: dataAccountingObject.value,
    columns: [
      {
        title: 'Mã đối tượng',
        dataField: 'accounting_object_code',
        width: 125,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên đối tượng',
        dataField: 'accounting_object_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 350,
        flexInQuickSearch: true,
      },
      {
        title: 'Mã số thuế',
        dataField: 'company_tax_code',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 125,
      },
    ],
    displayField: 'accounting_object_code',
    valueField: 'accounting_object_id',
    queryMode: queryMode.value,
    getDataComboOffline: getDataComboOffline,
    dropdownWidth: 600,
    quickAddMulti: [
      {
        valueField: 'EmployeeDetail',
        displayField: 'Thêm Cán bộ',
      },
      {
        valueField: 'CustomerVendorDetail',
        displayField: 'Thêm KH, NCC',
      },
    ],
    quickAddObject: true,
    quickSearch: 'RemoteQuickSearchPopup',
    quickSearchParam: {
      titleSearch: 'đối tượng',
      payload: {
        sort: 'is_employee,accounting_object_code',
      },
      module: 'accountingObject',
      idField: 'accounting_object_id',
    },
    comboboxLoadData: onAccountingObjectComboboxLoadData,
  };

  // config columns combo
  const accountingObjectComboCreditConfig = {
    data: dataAccountingObject.value,
    columns: [
      {
        title: 'Mã đối tượng',
        dataField: 'accounting_object_code',
        width: 125,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên đối tượng',
        dataField: 'accounting_object_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 350,
        flexInQuickSearch: true,
      },
      {
        title: 'Mã số thuế',
        dataField: 'company_tax_code',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 125,
      },
    ],
    displayField: 'accounting_object_code',
    valueField: 'accounting_object_id',
    modelValueField: 'credit_accounting_object_id',
    queryMode: queryMode.value,
    getDataComboOffline: getDataComboOffline,
    dropdownWidth: 600,
    quickAddMulti: [
      {
        valueField: 'EmployeeDetail',
        displayField: 'Thêm Cán bộ',
      },
      {
        valueField: 'CustomerVendorDetail',
        displayField: 'Thêm KH, NCC',
      },
    ],
    quickAddObject: true,
    quickSearch: 'RemoteQuickSearchPopup',
    quickSearchParam: {
      titleSearch: 'đối tượng',
      payload: {
        sort: 'is_employee,accounting_object_code',
      },
      module: 'accountingObject',
      idField: 'accounting_object_id',
    },
    comboboxLoadData: onAccountingObjectComboboxLoadData,
  };

  // config columns combo
  const accountingObjectComboDebitConfig = {
    data: dataAccountingObject.value,
    columns: [
      {
        title: 'Mã đối tượng',
        dataField: 'accounting_object_code',
        width: 125,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên đối tượng',
        dataField: 'accounting_object_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 350,
        flexInQuickSearch: true,
      },
      {
        title: 'Mã số thuế',
        dataField: 'company_tax_code',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 125,
      },
    ],
    displayField: 'accounting_object_code',
    valueField: 'accounting_object_id',
    modelValueField: 'debit_accounting_object_id',
    queryMode: queryMode.value,
    getDataComboOffline: getDataComboOffline,
    dropdownWidth: 600,
    quickAddMulti: [
      {
        valueField: 'EmployeeDetail',
        displayField: 'Thêm Cán bộ',
      },
      {
        valueField: 'CustomerVendorDetail',
        displayField: 'Thêm KH, NCC',
      },
    ],
    quickAddObject: true,
    quickSearch: 'RemoteQuickSearchPopup',
    quickSearchParam: {
      titleSearch: 'đối tượng',
      payload: {
        sort: 'is_employee,accounting_object_code',
      },
      module: 'accountingObject',
      idField: 'accounting_object_id',
    },
    comboboxLoadData: onAccountingObjectComboboxLoadData,
  };

  // config columns combo cho cán bộ
  const accountingObjectEmployeeComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã cán bộ',
        dataField: 'accounting_object_code',
        width: 150,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên cán bộ',
        dataField: 'accounting_object_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 450,
      },
    ],
    displayField: 'accounting_object_code',
    valueField: 'accounting_object_id',
    queryMode: 'remote',
    dropdownWidth: 600,
    quickAddMulti: [
      {
        valueField: 'EmployeeDetail',
        displayField: 'Thêm Cán bộ',
      },
    ],
    quickAddObject: true,
    quickSearch: 'RemoteQuickSearchPopup',
    quickSearchParam: {
      titleSearch: 'đối tượng',
      payload: {
        sort: 'is_employee,accounting_object_code',
      },
      module: 'accountingObject',
      idField: 'accounting_object_id',
    },
    comboboxLoadData: onAccountingObjectEmployeeComboboxLoadData,
  };

  return {
    accountingObjectComboConfig,
    accountingObjectEmployeeComboConfig,
    onCustomerComboboxLoadData,
    onAccountingObjectComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
    accountingObjectComboCreditConfig,
    accountingObjectComboDebitConfig,
  };
};
